import antdEnUS from "antd/es/locale/en_US";
import sqMsg from "../locales/sq_SQ.json";

const SqLang = {
    antd: antdEnUS,
    locale: "sq-SQ",
    messages: {
        ...sqMsg,
    },
};
export default SqLang;
